
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/smart_scroll/templates/notification"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='hub-feed-notificationJumpGlyph'></div>\n<div class='hub-feed-notificationMessage'>Unread Messages</div>\n";
},"useData":true});
    }).call(this);
  